<template>
    <div class="w-full h-full flex flex-col">
        <!-- Topbar for shape drawing -->
        <div class="flex flex-row gap-2 items-center p-2 bg-gray-200 border rounded-md mb-2" ref="containerTopRef">
            <span class="font-bold text-xs mr-2">Draw:</span>
            <button @click="setDrawMode('rect')"
                :class="['px-2 py-1 rounded', shapeDrawMode === 'rect' ? 'bg-blue-500 text-white' : 'bg-gray-300']"
                title="Rectangle">
                <svg width="20" height="20" viewBox="0 0 20 20">
                    <rect x="3" y="3" width="14" height="14" rx="2" fill="none" stroke="currentColor"
                        stroke-width="2" />
                </svg>
            </button>
            <button @click="setDrawMode('roundrect')"
                :class="['px-2 py-1 rounded', shapeDrawMode === 'roundrect' ? 'bg-blue-500 text-white' : 'bg-gray-300']"
                title="Rounded Rect">
                <svg width="20" height="20" viewBox="0 0 20 20">
                    <rect x="4" y="4" width="12" height="12" rx="5" fill="none" stroke="currentColor"
                        stroke-width="2" />
                </svg>
            </button>
            <button @click="setDrawMode('ellipse')"
                :class="['px-2 py-1 rounded', shapeDrawMode === 'ellipse' ? 'bg-blue-500 text-white' : 'bg-gray-300']"
                title="Ellipse">
                <svg width="20" height="20" viewBox="0 0 20 20">
                    <ellipse cx="10" cy="10" rx="7" ry="5" fill="none" stroke="currentColor" stroke-width="2" />
                </svg>
            </button>
            <button @click="setDrawMode('circle')"
                :class="['px-2 py-1 rounded', shapeDrawMode === 'circle' ? 'bg-blue-500 text-white' : 'bg-gray-300']"
                title="Circle">
                <svg width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="7" fill="none" stroke="currentColor" stroke-width="2" />
                </svg>
            </button>
            <div class="flex flex-col ">
                <span class="text-xs text-center">Fill</span>
                <color-picker v-model:pureColor="shapeFillColor" useType="pure" lang="En" />
            </div>
            <div class="flex flex-col ">
                <span class="text-xs text-center">Border</span>
                <color-picker v-model:pureColor="shapeStrokeColor" useType="pure" lang="En" />
            </div>

            <div class="flex flex-col">
                <span class="ml-2 text-xs">Stroke</span>
                <input type="number" min="0" max="20" v-model.number="shapeStrokeWidth"
                    class="ml-2 w-12 px-1 border rounded text-xs" />
            </div>
            <!-- <button @click="setDrawMode(null)" class="ml-4 px-2 py-1 bg-gray-400 text-white rounded">Exit Draw -->
            <!-- </button> -->
            <div class="flex-1"></div>
            <button @click="resetImage" class="ml-4 px-3 py-1 bg-red-500 text-white rounded flex items-center"
                title="Reset image">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4v5h5M19 11a8 8 0 11-7-7" />
                </svg>
                <span class="ml-1 text-xs">Reset</span>
            </button>
        </div>

        <div class="flex flex-1 flex-row w-full" ref="containerCenterRef">
            <!-- side bar -->
            <div class="flex flex-col flex-1 w-64 h-full  align-top gap-y-2 ">
                <div class="flex flex-col gap-2  p-2 border rounded bg-gray-50 w-full">
                    <button @click="reverseColors" class="px-3 py-1 bg-blue-500 text-white rounded">Reverse
                        Colors</button>

                </div>

                <div class="flex flex-row gap-2  p-2 border rounded bg-gray-50 w-full items-center">
                    <div class="flex flex-col items-center">
                        <label class="text-xs mb-1">Color select</label>
                        <input type="color" v-model="selColor" />
                    </div>
                    <div class="flex flex-col items-center">
                        <label class="text-xs mb-1">Change color</label>
                        <input type="color" v-model="targetColor" />
                    </div>
                    <form-button @click="recolorImage">Recolor</form-button>
                </div>
                <div class="flex flex-col gap-2  p-2 border rounded bg-gray-50 w-full ">

                    <div class="flex flex-col gap-2 flex-1">
                        <div class="flex items-center">
                            <label class="text-xs w-16">Bright</label>
                            <input type="range" min="-100" max="100" v-model="brightness" @input="applyAdjustments"
                                class="flex-1" />
                            <span class="ml-1 w-5 text-right">{{ brightness }}</span>
                        </div>
                        <div class="flex items-center">
                            <label class="text-xs w-16">Contrast</label>
                            <input type="range" min="-100" max="100" v-model="contrast" @input="applyAdjustments"
                                class="flex-1" />
                            <span class="ml-2 w-5 text-right">{{ contrast }}</span>
                        </div>
                        <div class="flex items-center">
                            <label class="text-xs w-16">Luminance</label>
                            <input type="range" min="-100" max="100" v-model="luminance" @input="applyAdjustments"
                                class="flex-1" />
                            <span class="ml-2 w-5 text-right">{{ luminance }}</span>
                        </div>
                    </div>
                </div>

                <!-- Resize Controls -->
                <div class="flex flex-1 flex-col mb-2 gap-2  p-2 border rounded bg-gray-50 w-full">
                    <div class="flex items-center gap-2">
                        <span class="font-bold text-xs">Resize</span>
                        <label class="flex items-center gap-1 text-xs">
                            <input type="checkbox" v-model="resizeMaintainAspect" />
                            <span>Maintain aspect</span>
                        </label>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <span class="w-9">Width:</span>
                        <input type="number" min="1" :max="resizeMaxWidth" v-model.number="resizeWidth"
                            @input="onResizeInput('width', 'px')" class="w-16 px-1 border rounded" /> px
                        <input type="number" min="1" max="500" v-model.number="resizeWidthPercent"
                            @input="onResizeInput('width', 'percent')" class="w-14 px-1 border rounded" /> %
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <span class="w-9">Height:</span>
                        <input type="number" min="1" :max="resizeMaxHeight" v-model.number="resizeHeight"
                            @input="onResizeInput('height', 'px')" class="w-16 px-1 border rounded" /> px
                        <input type="number" min="1" max="500" v-model.number="resizeHeightPercent"
                            @input="onResizeInput('height', 'percent')" class="w-14 px-1 border rounded" /> %
                    </div>
                    <button @click="applyResize" class="px-3 py-1 bg-blue-500 text-white rounded text-xs self-end">Apply
                        Resize</button>
                </div>

            </div>
            <div class="w-full  ml-2">
                <canvas ref="canvasRef" class=" border rounded w-full"
                    :style="`cursor: ${shapeDrawMode !== 'none' ? 'crosshair' : isPanning ? 'grabbing' : (canPan ? 'grab' : 'default')};`"
                    @click="onCanvasClick" @wheel.prevent="onCanvasWheel" @mousedown="onCanvasMouseDown"
                    @mousemove="onCanvasMouseMove" @mouseup="onCanvasMouseUp" @mouseleave="onCanvasMouseUp"></canvas>
            </div>
        </div>
        <!-- bottom status and action bar -->
        <div class="mb-2 " ref="containerBottomRef">
            <div class="text-xs text-gray-100 ">Width: {{ resizeWidth }} px &nbsp; | &nbsp; Height: {{
                resizeHeight
                }} px</div>
            <div class="flex justify-end w-full">
                <button @click="saveImage" class="px-4 py-1 bg-green-600 text-white rounded">Save</button>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, onMounted, nextTick, computed } from 'vue';

const props = defineProps({
    src: { type: String, required: true },
});
const emit = defineEmits(['update', 'save']);


const canvasRef = ref(null);
const selColor = ref('#000000');
const targetColor = ref('#ffffff');
const brightness = ref(0);
const contrast = ref(0);
const luminance = ref(0);
let imgElement = null;
let originalImageData = null;

// --- Resize State ---
const resizeMaintainAspect = ref(true);
const resizeWidth = ref(0);
const resizeHeight = ref(0);
const resizeWidthPercent = ref(100);
const resizeHeightPercent = ref(100);
const resizeMaxWidth = ref(0);
const resizeMaxHeight = ref(0);

const colorPickerActive = ref(false);

// --- Zoom and Pan State ---
const scale = ref(1);
const minScale = 1;
const maxScale = 8;
const offset = ref({ x: 0, y: 0 });
let lastPan = { x: 0, y: 0 };
const isPanning = ref(false);
const canPan = computed(() => scale.value > 1);

//drawing:
const shapeFillColor = ref('#00000000');
// const shapeFillColorAlpha = ref(255);
const shapeFillTransparent = ref(false);
const shapeStrokeColor = ref('#ffffff');
const shapeStrokeWidth = ref(4);

const shapeDrawMode = ref('none');
// Shape drawing state
let shapeStart = null; // {x, y} or null
let shapeCurrent = null; // {x, y} or null
let isDrawingShape = false;

function onCanvasWheel(e) {
    const canvas = canvasRef.value;
    if (!canvas || !imgElement) return;
    const rect = canvas.getBoundingClientRect();
    // Mouse position in canvas coordinates
    const mouseX = (e.clientX - rect.left) * (canvas.width / rect.width);
    const mouseY = (e.clientY - rect.top) * (canvas.height / rect.height);
    // Mouse position in image coordinates (before zoom)
    const imgX = (mouseX - offset.value.x) / scale.value;
    const imgY = (mouseY - offset.value.y) / scale.value;
    let delta = e.deltaY < 0 ? 1.1 : 0.9;
    let newScale = clamp(scale.value * delta, minScale, maxScale);
    if (newScale === scale.value) return;
    // Calculate new offset so the image pixel under the mouse stays under the mouse
    offset.value.x = mouseX - imgX * newScale;
    offset.value.y = mouseY - imgY * newScale;
    scale.value = newScale;
    clampPanOffset();
    drawImageToCanvas();
}


function getCanvasCoords(e) {
    const canvas = canvasRef.value;
    const rect = canvas.getBoundingClientRect();
    // Mouse position in canvas coordinates
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    // Adjust for pan/zoom
    const imgX = (x - offset.value.x) / scale.value;
    const imgY = (y - offset.value.y) / scale.value;
    return { x: imgX, y: imgY };
}

function onCanvasMouseDown(e) {
    if (shapeDrawMode.value !== 'none') {
        isDrawingShape = true;
        shapeStart = getCanvasCoords(e);
        shapeCurrent = { ...shapeStart };
    } else if (canPan.value) {
        isPanning.value = true;
        lastPan = { x: e.clientX, y: e.clientY };
    }
}

// Reset image to original
function resetImage() {
    setupImage();
    // Optionally reset adjustments and zoom/pan
    brightness.value = 0;
    contrast.value = 0;
    luminance.value = 0;
    scale.value = 1;
    offset.value = { x: 0, y: 0 };
}

function clampToImageBounds(pt) {
    // Clamp a point to the image bounds
    if (!imgElement) return pt;
    return {
        x: clamp(pt.x, 0, imgElement.naturalWidth),
        y: clamp(pt.y, 0, imgElement.naturalHeight)
    };
}

function onCanvasMouseMove(e) {
    if (isDrawingShape && shapeDrawMode.value !== 'none') {
        let pt = getCanvasCoords(e);
        shapeCurrent = clampToImageBounds(pt);
        // Redraw image and overlay temp shape
        drawImageToCanvas();
        // Draw temp shape
        const canvas = canvasRef.value;
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.translate(offset.value.x, offset.value.y);
        ctx.scale(scale.value, scale.value);
        drawShapeOnCanvas(
            ctx,
            shapeStart.x,
            shapeStart.y,
            shapeCurrent.x,
            shapeCurrent.y
        );
        ctx.restore();
    } else if (isPanning.value) {
        const dx = (e.clientX - lastPan.x) * (canvasRef.value.width / canvasRef.value.getBoundingClientRect().width);
        const dy = (e.clientY - lastPan.y) * (canvasRef.value.height / canvasRef.value.getBoundingClientRect().height);
        offset.value.x += dx;
        offset.value.y += dy;
        clampPanOffset();
        lastPan = { x: e.clientX, y: e.clientY };
        drawImageToCanvas();
    }
}


function onCanvasMouseUp(e) {
    if (isDrawingShape && shapeDrawMode.value !== 'none') {
        shapeCurrent = getCanvasCoords(e);
        // Draw shape permanently onto image
        const canvas = canvasRef.value;
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.translate(offset.value.x, offset.value.y);
        ctx.scale(scale.value, scale.value);
        drawShapeOnCanvas(
            ctx,
            shapeStart.x,
            shapeStart.y,
            shapeCurrent.x,
            shapeCurrent.y
        );
        ctx.restore();
        // Update imgElement with new image data
        const dataUrl = canvas.toDataURL();
        loadImage(dataUrl).then(newImg => {
            imgElement = newImg;
            drawImageToCanvas();
        });
        isDrawingShape = false;
        shapeStart = null;
        shapeCurrent = null;
        shapeDrawMode.value = 'none';
    } else if (isPanning.value) {
        isPanning.value = false;
    }
    // isPanning.value = false;

}

function onCanvasClick(e) {

}

function rgbToHex(r, g, b) {
    return (
        '#' +
        [r, g, b]
            .map(x => {
                const hex = x.toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            })
            .join('')
    );
}

function hexToRgb(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
        hex = hex.split('').map(x => x + x).join('');
    }
    const num = parseInt(hex, 16);
    return [
        (num >> 16) & 255,
        (num >> 8) & 255,
        num & 255
    ];
}

function loadImage(src) {
    return new Promise((resolve) => {
        const img = new window.Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => resolve(img);
        img.src = src;
    });
}

async function setupImage() {
    imgElement = await loadImage(props.src);
    await nextTick();
    // Set initial resize values
    resizeWidth.value = imgElement.naturalWidth;
    resizeHeight.value = imgElement.naturalHeight;
    resizeWidthPercent.value = 100;
    resizeHeightPercent.value = 100;
    resizeMaxWidth.value = imgElement.naturalWidth * 4;
    resizeMaxHeight.value = imgElement.naturalHeight * 4;
    drawImageToCanvas();
}
// --- Resize Logic ---
function onResizeInput(which, mode) {
    if (!imgElement) return;
    if (mode === 'px') {
        if (which === 'width') {
            resizeWidthPercent.value = Math.round((resizeWidth.value / imgElement.naturalWidth) * 100);
            if (resizeMaintainAspect.value) {
                resizeHeight.value = Math.round(imgElement.naturalHeight * (resizeWidth.value / imgElement.naturalWidth));
                resizeHeightPercent.value = Math.round((resizeHeight.value / imgElement.naturalHeight) * 100);
            }
        } else {
            resizeHeightPercent.value = Math.round((resizeHeight.value / imgElement.naturalHeight) * 100);
            if (resizeMaintainAspect.value) {
                resizeWidth.value = Math.round(imgElement.naturalWidth * (resizeHeight.value / imgElement.naturalHeight));
                resizeWidthPercent.value = Math.round((resizeWidth.value / imgElement.naturalWidth) * 100);
            }
        }
    } else if (mode === 'percent') {
        if (which === 'width') {
            resizeWidth.value = Math.round(imgElement.naturalWidth * (resizeWidthPercent.value / 100));
            if (resizeMaintainAspect.value) {
                resizeHeight.value = Math.round(imgElement.naturalHeight * (resizeWidthPercent.value / 100));
                resizeHeightPercent.value = resizeWidthPercent.value;
            }
        } else {
            resizeHeight.value = Math.round(imgElement.naturalHeight * (resizeHeightPercent.value / 100));
            if (resizeMaintainAspect.value) {
                resizeWidth.value = Math.round(imgElement.naturalWidth * (resizeHeightPercent.value / 100));
                resizeWidthPercent.value = resizeHeightPercent.value;
            }
        }
    }
}

function applyResize() {
    if (!imgElement) return;
    // Create a temp canvas to resize the image
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = resizeWidth.value;
    tempCanvas.height = resizeHeight.value;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.drawImage(imgElement, 0, 0, resizeWidth.value, resizeHeight.value);
    // Replace imgElement with the resized image
    const dataUrl = tempCanvas.toDataURL();
    loadImage(dataUrl).then(newImg => {
        imgElement = newImg;
        // Update resize state to match new image
        resizeWidth.value = imgElement.naturalWidth;
        resizeHeight.value = imgElement.naturalHeight;
        resizeWidthPercent.value = 100;
        resizeHeightPercent.value = 100;
        resizeMaxWidth.value = imgElement.naturalWidth * 4;
        resizeMaxHeight.value = imgElement.naturalHeight * 4;
        drawImageToCanvas();
    });
}

function drawImageToCanvas() {
    const canvas = canvasRef.value;
    if (!canvas || !imgElement) return;
    // Always use the image's natural size for the canvas
    canvas.width = imgElement.naturalWidth;
    canvas.height = imgElement.naturalHeight;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.translate(offset.value.x, offset.value.y);
    ctx.scale(scale.value, scale.value);
    ctx.drawImage(imgElement, 0, 0);
    ctx.restore();
    // Save original image data for adjustments (only if not zoomed/panned)
    if (scale.value === 1 && offset.value.x === 0 && offset.value.y === 0) {
        originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    }
}

onMounted(setupImage);
watch(() => props.src, async (val) => {
    await setupImage();
});

function saveImage() {
    const canvas = canvasRef.value;
    emit('save', canvas.toDataURL(), resizeWidth.value, resizeHeight.value);
}

function recolorImage() {
    const canvas = canvasRef.value;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(imgElement, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const sc = hexToRgb(selColor.value);
    const tc = hexToRgb(targetColor.value);
    for (let i = 0; i < imageData.data.length; i += 4) {
        const r = imageData.data[i];
        const g = imageData.data[i + 1];
        const b = imageData.data[i + 2];
        // If pixel matches selColor (tolerance for anti-aliasing)
        if (Math.abs(r - sc[0]) < 10 && Math.abs(g - sc[1]) < 10 && Math.abs(b - sc[2]) < 10) {
            imageData.data[i] = tc[0];
            imageData.data[i + 1] = tc[1];
            imageData.data[i + 2] = tc[2];
        }
    }
    ctx.putImageData(imageData, 0, 0);
}

function reverseColors() {
    const canvas = canvasRef.value;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(imgElement, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < imageData.data.length; i += 4) {
        imageData.data[i] = 255 - imageData.data[i];
        imageData.data[i + 1] = 255 - imageData.data[i + 1];
        imageData.data[i + 2] = 255 - imageData.data[i + 2];
    }
    ctx.putImageData(imageData, 0, 0);
}

function clamp(val, min, max) {
    return Math.max(min, Math.min(max, val));
}

function applyAdjustments() {
    const canvas = canvasRef.value;
    if (!canvas || !imgElement || !originalImageData) return;
    const ctx = canvas.getContext('2d');
    // Copy original data
    let imageData = ctx.createImageData(originalImageData.width, originalImageData.height);
    imageData.data.set(originalImageData.data);

    const b = parseInt(brightness.value) || 0;
    const c = parseInt(contrast.value) || 0;
    const l = parseInt(luminance.value) || 0;
    for (let i = 0; i < imageData.data.length; i += 4) {
        // Brightness
        imageData.data[i] = clamp(imageData.data[i] + b, 0, 255);
        imageData.data[i + 1] = clamp(imageData.data[i + 1] + b, 0, 255);
        imageData.data[i + 2] = clamp(imageData.data[i + 2] + b, 0, 255);
        // Contrast
        if (c !== 0) {
            let factor = (259 * (c + 255)) / (255 * (259 - c));
            imageData.data[i] = clamp(factor * (imageData.data[i] - 128) + 128, 0, 255);
            imageData.data[i + 1] = clamp(factor * (imageData.data[i + 1] - 128) + 128, 0, 255);
            imageData.data[i + 2] = clamp(factor * (imageData.data[i + 2] - 128) + 128, 0, 255);
        }
        // Luminance
        if (l !== 0) {
            let lum = 0.299 * imageData.data[i] + 0.587 * imageData.data[i + 1] + 0.114 * imageData.data[i + 2];
            lum = clamp(lum + l, 0, 255);
            let ratio = lum / (0.299 * imageData.data[i] + 0.587 * imageData.data[i + 1] + 0.114 * imageData.data[i + 2] || 1);
            imageData.data[i] = clamp(imageData.data[i] * ratio, 0, 255);
            imageData.data[i + 1] = clamp(imageData.data[i + 1] * ratio, 0, 255);
            imageData.data[i + 2] = clamp(imageData.data[i + 2] * ratio, 0, 255);
        }
    }
    ctx.putImageData(imageData, 0, 0);
}

function applyGradient() {
    const canvas = canvasRef.value;
    if (!canvas || !imgElement || !originalImageData) return;
    const ctx = canvas.getContext('2d');
    // Copy original data
    let imageData = ctx.createImageData(originalImageData.width, originalImageData.height);
    imageData.data.set(originalImageData.data);
    // Simple vertical gradient overlay (white to transparent)
    for (let y = 0; y < canvas.height; y++) {
        let alpha = 1 - y / canvas.height;
        for (let x = 0; x < canvas.width; x++) {
            let i = (y * canvas.width + x) * 4;
            imageData.data[i] = clamp(imageData.data[i] * alpha + 255 * (1 - alpha), 0, 255);
            imageData.data[i + 1] = clamp(imageData.data[i + 1] * alpha + 255 * (1 - alpha), 0, 255);
            imageData.data[i + 2] = clamp(imageData.data[i + 2] * alpha + 255 * (1 - alpha), 0, 255);
        }
    }
    ctx.putImageData(imageData, 0, 0);
}

function clampPanOffset() {
    const canvas = canvasRef.value;
    if (!canvas || !imgElement) return;
    const imgW = imgElement.naturalWidth * scale.value;
    const imgH = imgElement.naturalHeight * scale.value;
    // Clamp so image always covers the canvas
    const minX = Math.min(0, canvas.width - imgW);
    const maxX = Math.max(0, canvas.width - imgW);
    const minY = Math.min(0, canvas.height - imgH);
    const maxY = Math.max(0, canvas.height - imgH);
    offset.value.x = Math.min(Math.max(offset.value.x, minX), 0);
    offset.value.y = Math.min(Math.max(offset.value.y, minY), 0);
}

function setDrawMode(mode) {
    if (shapeDrawMode.value === mode) {
        shapeDrawMode.value = 'none';
    } else {
        shapeDrawMode.value = mode;
    }
}

function drawShapeOnCanvas(ctx, x1, y1, x2, y2) {
    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = shapeStrokeWidth.value || 2;
    ctx.strokeStyle = shapeStrokeColor.value || '#000';
    ctx.fillStyle = shapeFillColor.value || '#fff';
    const w = x2 - x1, h = y2 - y1;
    if (shapeDrawMode.value === 'rect') {
        ctx.rect(x1, y1, w, h);
    } else if (shapeDrawMode.value === 'roundrect') {
        const radius = Math.min(Math.abs(w), Math.abs(h)) / 5;
        if (ctx.roundRect) {
            ctx.roundRect(x1, y1, w, h, radius);
        } else {
            // fallback for browsers without roundRect
            ctx.moveTo(x1 + radius, y1);
            ctx.lineTo(x1 + w - radius, y1);
            ctx.quadraticCurveTo(x1 + w, y1, x1 + w, y1 + radius);
            ctx.lineTo(x1 + w, y1 + h - radius);
            ctx.quadraticCurveTo(x1 + w, y1 + h, x1 + w - radius, y1 + h);
            ctx.lineTo(x1 + radius, y1 + h);
            ctx.quadraticCurveTo(x1, y1 + h, x1, y1 + h - radius);
            ctx.lineTo(x1, y1 + radius);
            ctx.quadraticCurveTo(x1, y1, x1 + radius, y1);
        }
    } else if (shapeDrawMode.value === 'ellipse') {
        ctx.ellipse(x1 + w / 2, y1 + h / 2, Math.abs(w / 2), Math.abs(h / 2), 0, 0, 2 * Math.PI);
    } else if (shapeDrawMode.value === 'circle') {
        const r = Math.sqrt(w * w + h * h) / 2;
        ctx.arc(x1, y1, r, 0, 2 * Math.PI);
    }
    ctx.closePath();
    ctx.fill();
    if (shapeStrokeWidth.value > 0) ctx.stroke();
    ctx.restore();
}
</script>
